export default "__VITE_ASSET__JaGfyrGp__"